import { identity, isNil, pathOr } from "ramda";
import { createBrowserHistory } from "history";
import ReduxQuerySync from "redux-query-sync";

import { DLS_MODE } from "~/constants/presentation-modes";

import { selectRelativePage } from "~/store/ducks";
import {
  setDisplayMode,
  selectDisplayMode,
  setDlsActiveTab,
  selectDlsActiveTab
} from "~/store/ducks/user/uistate";
import {
  selectDlsActiveCategoryTitleAndPage,
  setDlsActiveCategoryAndPage
} from "~/store/ducks/domain/ui/embedded";
import { goToDestination } from "~/store/middlewares/page";
import { isInIFrame } from "~/utils";

export const browserHistory = createBrowserHistory();

export const querySyncParams = {
  p: {
    selector: selectRelativePage,
    action: goToDestination
  },
  ctab: {
    selector: selectDlsActiveTab,
    action: setDlsActiveTab,
    defaultValue: pathOr(
      "all",
      ["book", "initial", "sidebarRight", "dlsDefaultTab"],
      window.getClientConfiguration()
    )
  },
  c: {
    selector: selectDlsActiveCategoryTitleAndPage,
    action: setDlsActiveCategoryAndPage,
    defaultValue: `${pathOr(
      null,
      ["book", "initial", "sidebarRight", "dlsDefaultCategory"],
      window.getClientConfiguration()
    )}::1`
  }
};

const isDls = pathOr(
  false,
  ["book", "settings", "features", "dls"],
  window.getClientConfiguration()
);

if (isDls) {
  querySyncParams.m = {
    selector: selectDisplayMode,
    action: setDisplayMode,
    defaultValue: DLS_MODE
  };
}

export const querySyncEnhancer = ReduxQuerySync.enhancer({
  params: querySyncParams,
  initialTruth: "location",
  replaceState: isInIFrame(),
  history: browserHistory
});

// https://github.com/Treora/redux-query-sync/blob/master/src/redux-query-sync.js#L56
export function getQueryValues(query) {
  const queryValues = {};

  Object.entries(querySyncParams).forEach(
    ([param, { defaultValue, stringToValue = identity }]) => {
      const queryValue = query.get(param);
      let value;

      if (isNil(queryValue)) {
        value = defaultValue;
      } else {
        value = stringToValue(queryValue);
      }

      queryValues[param] = value;
    }
  );

  return queryValues;
}
